module.exports = __webpack_public_path__ + "img/knok_install_step1-4_poster.fab59a7a.png";